import Link from "next/link";

import { useStoreContext } from "@components/store/provider";
import { getBrandRoute } from "@constants/routes";

import main from "./main.module.scss";

const SearchedBrand = ({ data }) => {
  const { id, name, key } = data;
  const { storeBasePath } = useStoreContext();

  return (
    <Link
      className={`${main.searchedItem} ${main.brandItemBlock}`}
      prefetch={false}
      href={getBrandRoute({
        brandSlug: key || id,
        storeBasePath,
      })}
    >
      <span className={main.brandName}>{name}</span>
    </Link>
  );
};

export default SearchedBrand;
